import fire from '@store/firebase';
import { CollectionPath } from '@typings/collections.enum';

const firestore = fire.firestore();

type props = {
  uids: string[];
  data: { price?: number; materialItemID?: string; skillID?: string; memo?: string };
};
export async function saveWalletHistory({ uids, data }: props) {
  const ref = firestore.collection(CollectionPath.WALLET_HISTORY);

  return ref.add({ uids, ...data, createdAt: new Date() });
}
